import {
  Briefcase,
  Users,
  Home,
  User,
  FileText,
  Lightbulb,
  DollarSign,
  Building2,
  ShieldCheck,
  Heart,
  MoreHorizontal,
} from 'lucide-react';

export const TEMPLATE_CATEGORIES = [
  { slug: 'business', label: 'Business', icon: Briefcase },
  { slug: 'employment', label: 'Employment', icon: Users },
  { slug: 'real-estate', label: 'Real Estate', icon: Home },
  { slug: 'personal', label: 'Personal', icon: User },
  { slug: 'contracts', label: 'Contracts', icon: FileText },
  { slug: 'intellectual-property', label: 'Intellectual Property', icon: Lightbulb },
  { slug: 'finance', label: 'Finance', icon: DollarSign },
  { slug: 'corporate', label: 'Corporate', icon: Building2 },
  { slug: 'compliance', label: 'Compliance', icon: ShieldCheck },
  { slug: 'family', label: 'Family', icon: Heart },
  { slug: 'others', label: 'Others', icon: MoreHorizontal },
] as const;

export type TemplateCategory = (typeof TEMPLATE_CATEGORIES)[number]['slug'];
